import React, { useEffect, useState, useCallback } from "react";
import moment from "moment";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';

import { roundScaleDecimals, thousandFormat } from "services/helpers"


import { Row, Col } from "stories/layout";
import { Input } from "stories/forms";
import { Card, Typography, Button, Link, IconButton, Modal, Spinner, BreadcrumbsDynamic } from "stories/components";
import { PageHeader, PageContainer } from "components/Page"
import { TableAuto } from "stories/tables"
// import { httpGetExtendBasicData, httpGetBasicData} from "services/stocks"
import { httpGetInvestmentFunds} from "services/investment_fund"
import { httpGetStockData } from "services/stocks"
import OptionEdit from "views/app/OptionEdit/OptionEdit"
        
import StockMarketSelect from "components/Forms/StockMarketSelect/StockMarketSelect"
import CurrencySelect from "components/Forms/CurrencySelect/CurrencySelect" 
        

import { useAppContext } from "contexts/AppContext"
import { Pagination } from "stories/tables";


const StocksList = ({match, history, location}) => {
  
  const { t } = useTranslation();
  // const stocks = useStoreState((state) => state.stocks?.objects);
  // const loading = useStoreState((state) => state.stocks?.loading);
  const getBasicDataObjects = useStoreActions((actions) => actions.stocks.getObjects);
  // const count = useStoreState((state) => state.stocks?.count);
  const { getStockMarketName } = useAppContext()
  const [stocks, setStocks] = useState()
  const [count, setCount] = useState(0)
  const [loading, setLoading] = useState(false)


  const getOptions = () => {
    // setRows(exampleData);
    // setCount(exampleData.length)
    // setOptions(exampleData)
    // setCount(exampleData.length)
  }
  
  // Table
  // const [rows, setRows] = useState([])
  // const [count, setCount] = useState(0)
  const [filters, setFilters] = useState({
    limit: 30,
    offset:0,
    stock_market: "XHEL",
  })

  const getCrumbLinks = () => {
    const crumbLinks = [
      {name: t("Etusivu"), url: "/dashboard/"},
      {name: t("InvestmentFundList_title","Rahastot"), url: "/dashboard/investment_funds", optional: true, passed: true},
      {name: getStockMarketName(filters.stock_market), url: "/dashboard/stocks", optional: true, passed: false},

    ]

    //if location state include crumbLinks return them
    if (location?.state && location?.state?.crumbLinks) {
      const crumbLinks = [...location.state.crumbLinks]

      crumbLinks.push({name: t("InvestmentFundList_title","Rahastot"), url: "/dashboard/investment_funds"})
      crumbLinks.push({name: getStockMarketName(filters.stock_market), url: "/dashboard/stocks", optional: true})
      return crumbLinks
    }
    //else return default links
    return crumbLinks
  }



  
  useEffect(() => {
    const params = {...filters}
    params.ordering = "name"
    params.related_model_type= 40
    delete params.limit
    getBasicDataObjects(params)
    setLoading(true)
    params.limit = filters.limit
    httpGetInvestmentFunds(params).then(res => {
      setStocks(res.data?.results)
      setCount(res?.data?.count)
      setLoading(false)

    })
  }, [filters])
  
  const handleChange = ({target}) => {
    setFilters({
      ...filters,
      [target.name]: target.value,
    })
  }
  
  const headers = [
    { label: t("investment_fund_name", "name"), key: "name"},
    { label: t("investment_fund_price", "Hinta"), key: "latest_price"},
    { label: t("investment_fund_latest_price_date", "Kirjaus päivä"), key: "latest_date"},
    { label: t("investment_fund_isin", "isin"), key: "isin_code"},
    { label: t("investment_fund_listing_date", "Listautuminen pvm"), key: "listning_date"},
    { label: t("investment_fund_listing_exit_date", "Pois listautuminen pvm"), key: "listning_exit_date"},
    // { label: t("investment_fund_listing_number", "listing_number"), key: "listing_number"},
    // { label: t("investment_fund_size", "size"), key: "size"},
    { label: t("investment_fund_symbol", "symbol"), key: "symbol"},
    { label: t("investment_fund_old_symbol", "Vanha symboli"), key: "old_symbol"},
    { label: t("investment_fund_quotation_value", "Quotation value"), key: "quotation_value"},
    { label: t("investment_fund_list", "List"), key: "list"},
    { label: t("investment_fund_group", "Ryhmä"), key: "group"},
    { label: t("investment_fund_currency", "Valuutta"), key: "currency"},
    { label: t("investment_fund_country", "Maa"), key: "country"},
    { label: t("investment_fund_classification", "Classification"), key: "classification"},
    { label: t("investment_fund_actions", " "), key: "actions"},


  ];
  
  const paginationPrevious = () => {
    let offset = filters?.offset - Number(filters?.limit);
    if (offset < 0) {
      offset = 0;
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  
  const paginationNext = () => {
    let offset = filters?.offset + Number(filters?.limit);
    if (offset > filters?.count) {
      return
    }
    setFilters(f => ({
      ...f,
      offset: offset,
    }))
  }
  



  const getLatestStockDataUpdateDate = useCallback (() => {
    //time now
    const now = moment()

    let oldestDate= null
    let ThereIsNull = false
    
    if (stocks?.length > 0 && stocks?.[0]?.stock_data_latest?.stock_date) {
      //loop all stocks and get oldest stock date
      stocks.forEach(stock => {
        if (stock?.stock_data_latest?.stock_date) {
          const stockDate = moment(stock?.stock_data_latest?.stock_date)
          if (!oldestDate) {
            oldestDate = stockDate
          }
          if (stockDate.isBefore(oldestDate)) {
            oldestDate = stockDate
          }
          if (stockDate === null) {
            ThereIsNull = true
          }
        }
      })
    }


    //get latest stock data update date
    const latestStockDataUpdateDate = oldestDate
    let endOfInfoText = t("stocks_list_minutes_ago", "minuuttia sitten")
    //get difference between now and today start
    const diffNowAndTodayStart = now.diff(moment().startOf('day'), 'minutes')
    let styles = "text-success"

    //get difference between now and latest stock data update date
    let diff = now.diff(latestStockDataUpdateDate, 'minutes')

    // latestStockDataUpdateDate are older than yesterday at 20:00.
    if (diffNowAndTodayStart  + 240 < diff || oldestDate === null) {
      styles = "text-danger"
    }
    if (diff > 1440) {
      diff = now.diff(latestStockDataUpdateDate, 'days')
      endOfInfoText = t("stocks_list_days_ago", "päivää sitten")
    }
    else if (diff > 60) {
      diff = now.diff(latestStockDataUpdateDate, 'hours')
      endOfInfoText = t("stocks_list_hours_ago", "tuntia sitten")
    }
    return (
      <>
      {!loading && (
        <div className={`d-flex ${styles}`}>
        <i className="fas fa-history pr-1"/>
        {ThereIsNull ? (<Typography variant="h5" className="text-danger">{t("stocks_list_some_stocks_are_missing_data", "Joidenkin osakkeiden kurssidata vaillinaista")}</Typography>)
        : (<Typography variant="h5" className={styles}>{t("Päivitetty")} {diff} {endOfInfoText}</Typography> )}
        
        </div>
        )
      }
      </>
    )
  }, [stocks, loading])



  const getTableRows = useCallback(() => {
    //map all crumbs and return only key "passed" : true or undefined. Then set optional to false, so they are links then
    const getPassedCrumbLinks = () => {
      const crumbLinks = getCrumbLinks().filter(item => item?.passed === true || item?.passed === undefined).map(item => {
          return {
            ...item,
            optional: false,
          }
      })
      return crumbLinks
    }
    return stocks && stocks.map((row, index) => {
      return {
        ...row,
        name: (
          <Link to={{pathname:"/dashboard/investment_funds/rates/rate_list",search: `?stock_market=${filters?.stock_market} `, state: {crumbLinks:getPassedCrumbLinks(), fundId:row.id, fundName: row?.name, currency:row?.currency}}}>
          <h4 className=" text-dark m-0">
          {row?.name || "-"}
          </h4>
          </Link>
        ),
        // latest_price: roundScaleDecimals(row?.latest_price, 2),
        latest_price: row?.latest_price && {
          content: thousandFormat(roundScaleDecimals(row?.latest_price, 2)),
          className: "text-right",
        },
       
        actions: (
          <div className="d-flex justify-content-end">
          <Link to={{pathname:"/dashboard/investment_funds/rates/rate_list",search: `?stock_market=${filters?.stock_market} `, state: {crumbLinks: getPassedCrumbLinks(), fundId:row.id, fundName: row?.name, currency:row?.currency}}}>
            <Button className="btn-sm" color="secondary">
              <span className="fas fa-chart-line"></span> {t("")}
            </Button>
          </Link>
          </div>
          ),
      }
    })
  }, [stocks, filters])
  
  return (
    <>
      <PageHeader title={t("InvestmentFundList_title","Rahastot")} />
      <div className="d-flex">

      <BreadcrumbsDynamic links={getCrumbLinks()} />
      <div className="ml-auto">
        {/*stocks && stocks.length > 0 && getLatestStockDataUpdateDate()*/}
      </div>
     </div>

      <PageContainer>
      <div className="d-flex flex-row align-items-center mb-3">

        {  !loading && (
          <div className="d-flex align-items-center ml-auto">
            <div className="mx-2" variant="h4">{t("PrivateInvestmentFundsList_count", "Näytä")}</div>
            <Pagination 
              paginationOffset={filters?.offset}
              paginationLimit={filters?.limit}
              paginationCount={count}
              setFilters={setFilters}
              showPaginationCurrentPage={false}
              showPaginationNextAndPrevious={false}
              showVerticalBorders={false}
            />
            <div className="mx-2" variant="h4">{t("riviä")}</div>
            {/*
              <div className="ml-4">
                <CurrencySelect 
                  label={""}
                  disabled={true}
                />
              </div>
            */}
          </div>
        )}

      </div>
      
  
      <TableAuto
          showRowNumber={true}
          showId={true}
          checkboxes={false}
          headers={headers}
          headerColor={"light"}
          rows={getTableRows()}
          loading={loading}
          pagination={true}
          paginationPrevious={paginationPrevious}
          paginationNext={paginationNext}
          paginationOffset={filters?.offset}
          paginationLimit={filters?.limit}
          paginationCount={count}
          setFilters={setFilters}
        />
      </PageContainer>
    </>
  );
}

export default StocksList;
